import React, { useState } from "react";

function Salenftpop() {
  const [bundleCheck, setBundleCheck] = useState(false);
  const [bundleChecking, setBundleChecking] = useState(false);
  return (
    <>
      <section className="nft-popup sale">
        <div className="row">
          <div className="col-lg-12">
            <h1>List Items For Sale</h1>
          </div>
        </div>
        <div className="row sale-nft">
          <div className="col-lg-4">
            <img
              src={require(".././Assets/img/sale-card.png")}
              className="sales-img"
              alt="card"
            />
            <div className="pop-desc">
              <h5>Alpha Pass Gaming Arcade</h5>
              <div className="pop-innerdesc">
                <h6>Alpha pass</h6>
                <h5>0.6</h5>
              </div>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="toggles-head">
              <p>Type</p>
              <img
                src={require("../Assets/img/icon-exam.png")}
                alt="icon-exam"
              />
            </div>
            <div className="toggle-buttons">
              <p>Fixed Price</p>
              <p>Timed Auction</p>
            </div>
            <div className="toggles-head">
              <p>Type</p>
              <img
                src={require("../Assets/img/icon-exam.png")}
                alt="icon-exam"
              />
            </div>
            <div className="col-lg-12 form">
              <div className="col-lg-4">
                <input type="text" className="form-control" placeholder="ETH" />
              </div>
              <div className="col-lg-8">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Amount"
                />
              </div>
            </div>
            <div className="toggles-head">
              <p>Type</p>
              <img
                src={require("../Assets/img/icon-exam.png")}
                alt="icon-exam"
              />
            </div>
            <div className="col-lg-12 Duration">
              <input type="text" placeholder="Duration" />
            </div>
            <div className="col-lg-12 sell-toggle">
              <div className="sells-toggle-switch">
                <p>Sells as a bundle</p>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={bundleCheck}
                  onClick={(e) => setBundleCheck(e.target.checked)}
                />
                <span className="slider round"></span>
              </label>
            </div>
            {bundleCheck ? (
              <div className="col-lg-12 sales-form">
                <input
                  type="text"
                  placeholder="Bundle Name"
                  className="form-control"
                />
                <textarea
                  className="form-control"
                  placeholder="Bundle Description"
                />
              </div>
            ) : (
              ""
            )}
            <div className="col-lg-12 sell-toggle">
              <div className="sells-toggle-switch">
                <p>Reserve for specific buyer</p>
                <h5>This item can be purchased as soon as it is listed.</h5>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={bundleChecking}
                  onClick={(e) => setBundleChecking(e.target.checked)}
                />
                <span className="slider round"></span>
              </label>
            </div>

            {bundleChecking ? (
              <div className="col-lg-12 sales-form">
                <input
                  type="text"
                  placeholder="Bundle Name"
                  className="form-control"
                />
                {/* <textarea className="form-control" placeholder="Bundle Description" /> */}
              </div>
            ) : (
              ""
            )}
            <div className="toggles-head">
              <p>Fees</p>
              <img
                src={require("../Assets/img/icon-exam.png")}
                alt="icon-exam"
              />
            </div>
            <div className="toggles-head">
              <h6>Service Fee</h6>
              <h6>2.5%</h6>
            </div>
            <div className="col-lg-6 Listing-btn">
              <button>Complete Listing</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Salenftpop;
